import React, { useState } from 'react';
import { Button, Checkbox, Typography } from 'antd';
import Icon from '@mdi/react';
import { mdiLinkOff } from '@mdi/js';
import Confirmation from 'components/Dialogs/Confirmation';
import { useDisconnectIntegrationMutation } from 'modules/apps/api/apps.api';
import { snackbar } from 'components/notifications/notifications';

const DisconnectButton = ({ id, integration, name }) => {
  const [disconnectIntegration, { isLoading }] = useDisconnectIntegrationMutation();
  const [widthData, setWidthData] = useState(true);

  const handleDisconnect = () => {
    disconnectIntegration({
      integration_id: id,
      integration_type: integration,
      width_data: widthData,
    })
      .unwrap()
      .then(() => {
        snackbar.success(`${name} successfully disconnected.`);
      })
      .catch((err) => {
        snackbar.error(`Error disconnecting ${name}.`);
      });
  };

  return (
    <Confirmation
      type='warning'
      onClick={(e) => e.stopPropagation()}
      onConfirm={handleDisconnect}
      description={
        <div className='grid gap-1 my-1'>
          <Typography className='text-sm'>Are you sure you want to disconnect?</Typography>
          <Checkbox
            checked={widthData}
            onClick={(e) => {
              e.stopPropagation();
              setWidthData(e.target.checked);
            }}
            style={{ textDecoration: 'underline' }}
          >
            Disconnect with leads
          </Checkbox>
        </div>
      }
    >
      <Button loading={isLoading} icon={<Icon path={mdiLinkOff} size={0.6} />}>
        Disconnect
      </Button>
    </Confirmation>
  );
};

export default DisconnectButton;
